const products = [
    
    // {
    //     id: "1",
    //     img: "/Images/Ourteam/team/27.jpg",
    //     Mname:"KANISHKA AGARWAL",
    //     designation:"Social Media Manager",
    //    // calendly: "https://calendly.com/kanishka-orionmarineconcepts",
    // },
    {
        id: "1",
        img: "/Images/Ourteam/team/kanika.jpg",
        Mname:"Kanika Chugh",
        designation:"Sr. Hr Executive"
    }

]

export default products